export default __webpack_public_path__ + "static/media/tick-circle.inline.0b584d7f.svg";